export const classes = {
  card: 'flex items-center justify-between',
  userWrapper: 'flex items-center',
  welcome: 'font-bold text-sm text-grey-4',
  userText: 'ml-4 flex flex-col justify-center',
  buttonsWrapper: 'flex items-center opacity-0',
  button: 'border border-grey-3 p-6 mx-2',
  icon: 'text-2xl text-grey-6',
};
